var calculateAndSetNewPosition;

calculateAndSetNewPosition = function(start, element) {
  var newTopPosition;
  newTopPosition = start - $(window).scrollTop();
  if (newTopPosition < 0) {
    newTopPosition = 0;
  }
  return $(element).css('top', newTopPosition);
};

$.fn.affix = function() {
  return $(this).each(function(idx, ele) {
    var startingTopPosition;
    startingTopPosition = $(ele).position().top;
    calculateAndSetNewPosition(startingTopPosition, ele);
    return $(window).on('scroll', function() {
      return calculateAndSetNewPosition(startingTopPosition, ele);
    });
  });
};
